
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('rect',{attrs:{"transform":"rotate(90 101 102)","x":"44","y":"95","width":"114","height":"14","rx":"7"}}),_c('rect',{attrs:{"transform":"rotate(45 86 137)","x":"59","y":"130","width":"54","height":"14","rx":"7"}}),_c('rect',{attrs:{"transform":"scale(-1 1) rotate(45 0 -143.049)","x":"89","y":"130","width":"54","height":"14","rx":"7"}})])])
          )
        }
      }
    